<template>
  <div class="edit-profile">
    <b-card>
      <div class="edit-profile_header card-padding w-100">
        <div class="d-flex align-items-center justify-content-between w-100">
          <span class="header__label">Edit Profile</span>
        </div>
      </div>
      <div class="card-padding pt-0">
        <div class="row">
          <div class="col-12 col-md-4">
            <atom-input
              v-model="userData.username"
              title="Username"
              placeholder="Username"
              :isAsterisk="true"
              :isError="isValidate && !userData.username"
              :isDisable="true"
              errorMessage="Please enter username"
            ></atom-input>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12 col-md-4 mt-1 mt-md-0">
            <atom-input
              v-model="userData.firstname"
              title="Firstname"
              placeholder="Firstname"
              :isAsterisk="true"
              :isError="isValidate && !userData.firstname"
              errorMessage="Please enter firstname"
            ></atom-input>
          </div>
          <div class="col-12 col-md-4 mt-1 mt-md-0">
            <atom-input
              v-model="userData.lastname"
              title="Lastname"
              placeholder="Lastname"
              :isAsterisk="true"
              :isError="isValidate && !userData.lastname"
              errorMessage="Please enter lastname"
            ></atom-input>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12 col-md-4 mt-1 mt-md-0">
            <atom-input
              v-model="userData.companyPosition"
              title="Company Position"
              placeholder="Company Position"
            ></atom-input>
          </div>
          <div class="col-12 col-md-4 mt-1 mt-md-0">
            <atom-input
              v-model="userData.companyDepartment"
              title="Company Department"
              placeholder="Company Department"
            ></atom-input>
          </div>
          <div class="col-12 col-md-4 mt-1 mt-md-0">
            <atom-input
              v-model="userData.companySection"
              title="Company Section"
              placeholder="Company Section"
            ></atom-input>
          </div>
        </div>
      </div>

      <hr class="card__line" />

      <div class="card-padding">
        <span class="header__label">Contact</span>
        <span
          v-if="isValidate && !isHaveEmailAndPhone"
          class="d-block font-size-12 text-color-danger"
        >
          * Both an email and a phone number are required
        </span>
        <div class="row mt-1">
          <div class="col-12 col-md-6 mt-1 mt-md-0">
            <span>EMAIL<label class="atom-input--asterisk">*</label></span>
            <div
              class="contact-card"
              v-for="email in userData.emails"
              :key="email.id"
            >
              <atom-contact-detail
                contactType="email"
                :contactId="email.id"
                :contactData="email.email"
                :isPrimary="email.isPrimary"
                @onClickMakePrimary="onClickMakePrimaryEmail"
                @onClickDelete="onClickDeleteEmail"
              ></atom-contact-detail>
            </div>
            <div class="email-card"></div>
            <div v-if="!isAddingNewEmail" class="button-wrapper">
              <div
                class="button-dash box-dashed"
                @click="onClickAddNewEmailButton"
              >
                <feather-icon
                  class="icon-size-24px text-primary"
                  icon="PlusCircleIcon"
                ></feather-icon>
                <label class="button--text">Add New Email</label>
              </div>
            </div>
            <div
              v-else-if="isAddingNewEmail"
              class="new-contact-textbox-wrapper mt-1"
            >
              <atom-input
                v-model="newEmailData"
                title="Email"
                placeholder="Email"
                :errorMessage="isErrorNewEmailMessage"
                :isAsterisk="true"
                :isError="isErrorNewEmailData"
              ></atom-input>
              <div
                class="button-new-contact mt-1 d-flex justify-content-end align-items-end"
              >
                <atom-button
                  buttonId="confirm-add-new-email"
                  :isOnlyIcon="true"
                  iconLeft="CheckIcon"
                  @click="onClickAddNewEmail"
                ></atom-button>
                <atom-button
                  buttonId="cancel-add-new-email"
                  class="ml-1"
                  :isOnlyIcon="true"
                  iconLeft="XIcon"
                  buttonStyle="border"
                  buttonColor="secondary"
                  @click="onClickCancelAddNewEmail"
                ></atom-button>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mt-1 mt-md-0">
            <span>PHONE<label class="atom-input--asterisk">*</label></span>
            <div
              class="contact-card"
              v-for="phone in userData.phones"
              :key="phone.id"
            >
              <atom-contact-detail
                contactType="phone"
                :contactId="phone.id"
                :contactData="phone.phone"
                :isPrimary="phone.isPrimary"
                @onClickMakePrimary="onClickMakePrimaryPhone"
                @onClickDelete="onClickDeletePhone"
              ></atom-contact-detail>
            </div>
            <div v-if="!isAddingNewPhone" class="button-wrapper">
              <div
                class="button-dash box-dashed"
                @click="onClickAddNewPhoneButton"
              >
                <feather-icon
                  class="icon-size-24px text-primary"
                  icon="PlusCircleIcon"
                ></feather-icon>
                <label class="button--text">Add New Phone</label>
              </div>
            </div>
            <div
              v-else-if="isAddingNewPhone"
              class="new-contact-textbox-wrapper mt-1"
            >
              <atom-input
                v-model="newPhoneData"
                title="Phone"
                placeholder="Phone"
                :errorMessage="isErrorNewPhoneMessage"
                :isAsterisk="true"
                :isError="isErrorNewPhoneData"
              ></atom-input>
              <div
                class="button-new-contact mt-1 d-flex justify-content-end align-items-end"
              >
                <atom-button
                  buttonId="confirm-add-new-phone"
                  :isOnlyIcon="true"
                  iconLeft="CheckIcon"
                  @click="onClickAddNewPhone"
                ></atom-button>
                <atom-button
                  buttonId="cancel-add-new-phone"
                  class="ml-1"
                  :isOnlyIcon="true"
                  iconLeft="XIcon"
                  buttonStyle="border"
                  buttonColor="secondary"
                  @click="onClickCancelAddNewPhone"
                ></atom-button>
              </div>
            </div>
          </div>
          <!-- <div class="col-12 col-md-4 mt-1 mt-md-0">
            <span>LINE TOKEN</span>
            <div
              class="contact-card"
              v-for="lineToken in userData.lineTokens"
              :key="lineToken.id"
            >
              <atom-contact-detail
                contactType="lineToken"
                :contactId="lineToken.id"
                :contactData="lineToken.lineTokenAlias"
                :contactSubData="lineToken.lineToken"
                :isPrimary="lineToken.isPrimary"
                @onClickDelete="onClickDeleteLineToken"
              ></atom-contact-detail>
            </div>
            <div
              v-if="
                !isAddingNewLineToken &&
                userData.lineTokens &&
                userData.lineTokens.length === 0
              "
              class="button-wrapper"
            >
              <div
                class="button-dash box-dashed"
                @click="onClickAddNewLineTokenButton"
              >
                <feather-icon
                  class="icon-size-24px text-primary"
                  icon="PlusCircleIcon"
                ></feather-icon>
                <label class="button--text">Add New Line Token</label>
              </div>
            </div>
            <div
              v-else-if="isAddingNewLineToken"
              class="new-contact-textbox-wrapper mt-1"
            >
              <atom-input
                class="mb-1"
                v-model="newLineTokenAlias"
                title="Line Token Alias"
                placeholder="Line Token Alias"
                errorMessage="Line token alias cannot be blank"
                :isAsterisk="true"
                :isError="isErrorNewLineTokenAliasEmpty"
              ></atom-input>
              <atom-text-area
                v-model="newLineTokenData"
                title="Line Token"
                placeholder="Line Token"
                errorMessage="Please enter valid line token"
                :isAsterisk="true"
                :isError="isErrorNewLineTokenDataEmpty"
              >
              </atom-text-area>
              <div
                class="button-new-contact mt-1 d-flex justify-content-end align-items-end"
              >
                <atom-button
                  buttonId="confirm-add-new-line-token"
                  :isOnlyIcon="true"
                  iconLeft="CheckIcon"
                  @click="onClickAddNewLineToken"
                ></atom-button>
                <atom-button
                  buttonId="cancel-add-new-line-token"
                  class="ml-1"
                  :isOnlyIcon="true"
                  iconLeft="XIcon"
                  buttonStyle="border"
                  buttonColor="secondary"
                  @click="onClickCancelAddNewLineToken"
                ></atom-button>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <hr class="card__line" />

      <div class="card-padding">
        <span class="header__label">General Settings</span>
        <div class="row mt-2">
          <div class="col-12 col-md-6">
            <div class="d-flex justify-content-between">
              <div class="d-flex gap-8px">
                <feather-icon class="text-body" icon="BellIcon" size="21" />
                <div>Notification Sound</div>
              </div>
              <atom-switch v-model="userData.isEnableNotiSound" />
            </div>
          </div>
        </div>
      </div>

      <hr class="card__line" />

      <div class="card-padding">
        <div class="d-flex justify-content-end">
          <atom-button
            buttonId="save-account"
            class="mr-1"
            :isDisable="
              !isChangeUserData || (!isSuccessFormUpdate && isValidate)
            "
            @click="onClickSaveAccount"
            >Save Change
          </atom-button>

          <atom-button
            buttonId="create-new-account"
            buttonStyle="border"
            buttonColor="secondary"
            @click="onClickCancel"
            >Cancel
          </atom-button>
        </div>
      </div>
    </b-card>
    <footer style="height: 28px"></footer>

    <molecule-modal-dialog
      :modalId="modalConfirmSave"
      :isTextCenter="true"
      icon="AlertCircleIcon"
      :textTitle="`Do you want to save “${userData.username}”?`"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="updateUserData"
    ></molecule-modal-dialog>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomContactDetail from "@/components/atoms/AtomContactDetail.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import VueScreenSize from "vue-screen-size"
import store from "@/store/index"
import { mapActions, mapGetters } from "vuex"

import { getProfile, updateProfile } from "@/api/ims/api-profile-ims"
import { updateUserPreference } from "@/api/api-module1"

export default {
  name: "EditProfile",
  components: {
    BCard,
    AtomInput,
    AtomButton,
    AtomContactDetail,
    AtomSwitch,
    AtomTextArea,
    MoleculeModalDialog,
  },
  mixins: [
    mixins,
    mixinsValidator,
    mixinsObjectHelper,
    VueScreenSize.VueScreenSizeMixin,
  ],
  data() {
    return {
      userData: {
        status: "",
        username: "",
        password: "",
        firstname: "",
        lastname: "",
        departmentIds: null,
        siteIds: null,
        companyPosition: "",
        companyDepartment: "",
        companySection: "",
        emails: [],
        phones: [],
        lineTokens: [],
        isEnableNotiSound: null,
      },

      originalUserData: {
        status: "",
        username: "",
        password: "",
        firstname: "",
        lastname: "",
        departmentIds: null,
        siteIds: null,
        companyPosition: "",
        companyDepartment: "",
        companySection: "",
        emails: [],
        phones: [],
        lineTokens: [],
        isEnableNotiSound: null,
      },

      permissionList: [],

      isAddingNewEmail: false,
      newEmailData: "",
      validateNewEmailTrigger: false,

      isAddingNewPhone: false,
      newPhoneData: "",
      validateNewPhoneTrigger: false,

      isAddingNewLineToken: false,
      newLineTokenAlias: "",
      newLineTokenData: "",
      validateNewLineTokenTrigger: false,

      isChangeUserData: false,
      isValidate: false,
      modalConfirmSave: "confirm-save-user",
    }
  },
  computed: {
    ...mapGetters("commonStore", ["getNotificationSoundEnabled"]),

    screenWidth() {
      return this.$vssWidth
    },
    isHaveEmailAndPhone() {
      return (
        this.userData.emails?.length > 0 && this.userData.phones?.length > 0
      )
    },
    isErrorNewEmailData() {
      return this.validateNewEmailTrigger
        ? this.isEmptyString(this.newEmailData) ||
            this.isInvalidEmail(this.newEmailData) ||
            this.compareDuplicate(
              this.newEmailData,
              this.userData.emails,
              "email"
            )
        : false
    },
    isErrorNewEmailMessage() {
      return this.compareDuplicate(
        this.newEmailData,
        this.userData.emails,
        "email"
      )
        ? "Please enter different email"
        : "Please enter valid email"
    },
    isErrorNewPhoneData() {
      return this.validateNewPhoneTrigger
        ? this.isEmptyString(this.newPhoneData) ||
            this.isInvalidPhoneNumber(this.newPhoneData) ||
            this.compareDuplicate(
              this.newPhoneData,
              this.userData.phones,
              "phone"
            )
        : false
    },
    isErrorNewPhoneMessage() {
      return this.compareDuplicate(
        this.newPhoneData,
        this.userData.phones,
        "phone"
      )
        ? "Please enter different phone"
        : "Please enter valid phone"
    },
    isErrorNewLineTokenAliasEmpty() {
      return this.validateNewLineTokenTrigger
        ? this.isEmptyString(this.newLineTokenAlias)
        : false
    },
    isErrorNewLineTokenDataEmpty() {
      return this.validateNewLineTokenTrigger
        ? this.isEmptyString(this.newLineTokenData)
        : false
    },
    isSuccessFormUpdate() {
      return (
        this.userData.username !== "" &&
        this.userData.firstname !== "" &&
        this.userData.lastname !== "" &&
        this.userData.emails?.length !== 0 &&
        this.userData.phones?.length !== 0 &&
        this.userData.isEnableNotiSound !== null
      )
    },
  },
  watch: {
    screenWidth: {
      deep: true,
      immediate: true,
      handler() {
        if (this.screenWidth < 1200) {
          store.dispatch("appConfig/setLayoutSidebar", true)
        } else {
          store.dispatch("appConfig/setLayoutSidebar", false)
        }
      },
    },
    userData: {
      deep: true,
      handler() {
        this.checkDataChanges()
      },
    },
  },
  async mounted() {
    await this.getUserData()
  },
  methods: {
    ...mapActions("appPermission", ["setInternalFullName"]),
    ...mapActions("commonStore", ["setNotificationSoundEnabled"]),

    async getUserData() {
      this.showLoading(true)
      await getProfile()
        .then((response) => {
          this.userData = {
            username: response.data.username,
            status: response.data.status,
            firstname: response.data.firstName,
            lastname: response.data.lastName,
            companyPosition: response.data.companyPosition,
            companyDepartment: response.data.companyDepartment,
            companySection: response.data.companySection,
            emails: response.data.emails.sort((email) =>
              email.isPrimary ? -1 : 1
            ),
            phones: response.data.phones.sort((phone) =>
              phone.isPrimary ? -1 : 1
            ),
            isEnableNotiSound: this.getNotificationSoundEnabled,
          }
          this.originalUserData = this.deepCopyObject(this.userData)
        })
        .finally(() => this.showLoading(false))
    },

    async updateUserData() {
      const emails = this.userData.emails.map(({ id, ...rest }) => rest)
      const phones = this.userData.phones.map(({ id, ...rest }) => rest)

      const data = {
        firstName: this.userData.firstname,
        lastName: this.userData.lastname,
        companyPosition: this.userData.companyPosition,
        companyDepartment: this.userData.companyDepartment,
        companySection: this.userData.companySection,
        emails: emails,
        phones: phones,
      }
      await updateProfile(data)
        .then(async () => {
          this.isValidate = false
          this.$bvModal.hide(this.modalConfirmSave)

          const response = await updateUserPreference({
            notificationSound: this.userData.isEnableNotiSound,
          })
          if (response) {
            this.setNotificationSoundEnabled(this.userData.isEnableNotiSound)
          }

          // const fullName = `${this.userData.firstname} ${this.userData.lastname}`
          // this.setInternalFullName(fullName)
          await this.getUserData()
          this.toastSuccess("Update user successfully")
        })
        .catch(() => this.toastError("Update user failed"))
        .finally(() => this.showLoading(false))
    },

    checkDataChanges() {
      this.isChangeUserData = this.compareIsChangeObject(
        this.userData,
        this.originalUserData
      )
    },

    onClickSaveAccount() {
      this.isValidate = true
      if (this.isSuccessFormUpdate) {
        this.$bvModal.show(this.modalConfirmSave)
      }
    },
    onClickCancel() {
      this.$router.go(-1)
    },

    setNewEmailDataToDefault() {
      this.newEmailData = ""
    },
    setNewPhoneDataToDefault() {
      this.newPhoneData = ""
    },
    setNewLineTokenDataToDefault() {
      this.newLineTokenData = ""
      this.newLineTokenAlias = ""
    },
    onClickAddNewEmailButton() {
      this.isAddingNewEmail = true
    },
    onClickAddNewPhoneButton() {
      this.isAddingNewPhone = true
    },
    onClickAddNewLineTokenButton() {
      this.isAddingNewLineToken = true
    },
    onClickAddNewEmail() {
      this.validateNewEmailTrigger = true
      if (!this.isErrorNewEmailData) {
        const isPrimary = this.userData.emails?.length === 0
        const newEmail = {
          email: this.newEmailData,
          isPrimary: isPrimary,
        }
        this.userData.emails.push(newEmail)

        this.isAddingNewEmail = false
        this.setNewEmailDataToDefault()
        this.validateNewEmailTrigger = false
      }
    },
    onClickAddNewPhone() {
      this.validateNewPhoneTrigger = true
      if (!this.isErrorNewPhoneData) {
        const isPrimary = this.userData.phones?.length === 0
        const newPhone = {
          phone: this.newPhoneData,
          isPrimary: isPrimary,
        }
        this.userData.phones.push(newPhone)

        this.isAddingNewPhone = false
        this.setNewPhoneDataToDefault()
        this.validateNewPhoneTrigger = false
      }
    },
    onClickAddNewLineToken() {
      this.validateNewLineTokenTrigger = true
      if (
        !this.isErrorNewLineTokenDataEmpty &&
        !this.isErrorNewLineTokenAliasEmpty
      ) {
        const isPrimary = this.userData.lineTokens?.length === 0
        const newLineToken = {
          lineTokenAlias: this.newLineTokenAlias,
          lineToken: this.newLineTokenData,
          isPrimary: isPrimary,
        }
        this.userData.lineTokens.push(newLineToken)

        this.isAddingNewLineToken = false
        this.setNewLineTokenDataToDefault()
        this.validateNewLineTokenTrigger = false
      }
    },
    onClickMakePrimaryEmail(index, email) {
      const selectedEmail = this.userData.emails.find(
        (item) => item.email === email
      )
      if (selectedEmail) {
        selectedEmail.isPrimary = true
        this.userData.emails.forEach((item) => {
          if (item.email !== email) {
            item.isPrimary = false
          }
        })
        this.userData.emails.sort((email) => (email.isPrimary ? -1 : 1))
      }
    },
    onClickMakePrimaryPhone(index, phone) {
      const selectedPhone = this.userData.phones.find(
        (iten) => iten.phone === phone
      )
      if (selectedPhone) {
        selectedPhone.isPrimary = true
        this.userData.phones.forEach((item) => {
          if (item.phone !== phone) {
            item.isPrimary = false
          }
        })
        this.userData.phones.sort((phone) => (phone.isPrimary ? -1 : 1))
      }
    },
    onClickDeleteEmail(index, email) {
      this.userData.emails = this.userData.emails.filter(
        (item) => item.email !== email
      )
    },
    onClickDeletePhone(index, phone) {
      this.userData.phones = this.userData.phones.filter(
        (item) => item.phone !== phone
      )
    },
    onClickDeleteLineToken() {
      this.userData.lineTokens = []
    },
    onClickCancelAddNewEmail() {
      this.isAddingNewEmail = false
      this.setNewEmailDataToDefault()
      this.validateNewEmailTrigger = false
    },
    onClickCancelAddNewPhone() {
      this.isAddingNewPhone = false
      this.setNewPhoneDataToDefault()
      this.validateNewPhoneTrigger = false
    },
    onClickCancelAddNewLineToken() {
      this.isAddingNewLineToken = false
      this.setNewLineTokenDataToDefault()
      this.validateNewLineTokenTrigger = false
    },

    compareDuplicate(newData, contactList, contactType) {
      switch (contactType) {
        case "email":
          return contactList.some((item) => item.email === newData)
        case "phone":
          return contactList.some((item) => item.phone === newData)
        default:
          return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.edit-profile_header {
  display: flex;
  flex-direction: column;
}

.contact-card {
  margin-top: 10px;
  margin-bottom: 15px;
}

// .button-wrapper,
// .contact-card,
// .new-contact-textbox-wrapper,
// .button-new-contact {
//   max-width: 550px;
// }

.button-dash {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button--text {
  margin-left: 10px;
  margin-bottom: 0;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.box-dashed {
  height: 60px;
  border: 1px dashed rgba(115, 103, 240, 0.4);
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 5px;
  &:hover {
    background-color: #f9f9fe;
  }
}

.atom-input--asterisk {
  color: #ea5455;
  font-size: 14px;
  margin-bottom: 0;
}

.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

@media screen and (min-width: 576px) {
  .edit-profile_header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

// @media screen and (min-width: 768px) {
//   .button-wrapper,
//   .contact-card,
//   .new-contact-textbox-wrapper,
//   .button-new-contact {
//     max-width: 550px;
//   }
// }
</style>
